import { createFileRoute } from "@tanstack/react-router";
import { Navbar, Footer } from "@/components/hilltop";
import { FacilitiesContent } from "@/components/hilltop/FacilitiesContent";

export const Route = createFileRoute("/_public/facilities")({
  component: FacilitiesPage,
});

function FacilitiesPage() {
  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <FacilitiesContent />
      <Footer />
    </div>
  );
}
